import React, { useContext, Fragment } from 'react';
import { Link } from 'react-router-dom';

import { StartFarmContext } from '../../context/startFarmContext';
import { ComponentContext } from '../../context/componentContext';

import Progress from '../../components/starFarm/FarmExperience/Progress';
import Support from './Support';

import Logo from '../../images/logo.png';

const AuthHeader = ({ startFarm }) => {
  const { steps, activeStep } = useContext(StartFarmContext);
  const { handleToggleSupport } = useContext(ComponentContext);
  return (
    <Fragment>
      <div className="fixed z-50 bg-white shadow w-full">
        <div className="container mx-auto px-2 md:px-2 lg:px-0">
          <div className="flex flex-wrap md:justify-between items-center h-16">
            {startFarm ? (
              <Fragment>
                <Link to="/home">
                  <img className="h-10" src={Logo} alt="Complete Farmer Logo" />
                </Link>

                <ul className="hidden md:flex flex-wrap items-center">
                  {steps.map((step, i) => (
                    <li
                      key={i}
                      className={
                        activeStep >= i
                          ? 'flex items-center text-cf-dark font-bold'
                          : 'flex items-center px-4'
                      }
                    >
                      <Progress step={step} activeStep={activeStep} i={i} />
                    </li>
                  ))}
                </ul>

                <div className="flex flex-wrap items-center ml-8 md:ml-4 lg:ml-8">
                  <small className="text-xs md:text-sm mr-4">Need help?</small>
                  <button
                    onClick={handleToggleSupport}
                    className="bg-cf-200 text-cf-300 py-2 px-3 text-xs md:text-sm rounded"
                  >
                    Contact support
                  </button>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <a href="https://www.completefarmer.com">
                  <img className="h-10" src={Logo} alt="Complete Farmer Logo" />
                </a>

                <div className="flex flex-wrap items-center ml-12">
                  <small className="mr-4 text-xs md:text-sm">Need help?</small>
                  <button
                    onClick={handleToggleSupport}
                    className="bg-cf-200 text-cf-300 py-1 lg:py-2 px-3 text-xs md:text-sm rounded"
                  >
                    Contact support
                  </button>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
      <Support />
    </Fragment>
  );
};

export default AuthHeader;
